export function getLastRowIndexStart(array: any[], columns: number) {
    return array.length - (array.length % columns) - (array.length % columns === 0 ? columns : 0);
}
